export default "__VITE_ASSET__C8RssfLy__"